import React from 'react';
import PropTypes from 'prop-types';
import Link from '@salesforce/retail-react-app/app/components/link';

import {Box, Flex, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

/** Decorative chevron between breadcrumb items (matches design `>` separators). */
const BreadcrumbChevronSeparator = (props) => (
  <Box
    as="span"
    aria-hidden
    lineHeight={0}
    {...props}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M10 8l4 4-4 4"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        color="currentColor"
      />
    </svg>
  </Box>
);

/**
 * Breadcrumbs
 * @param {Object} props
 * @param {Function} props.onClick
 */
const Breadcrumbs = ({
  breadcrumbs,
  variant,
  ...props
}) => {
  const styles = useMultiStyleConfig('Breadcrumbs', {variant});

  return (
    <Flex {...styles.breadcrumbs} {...props}>
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.id || index}>
          {breadcrumb.href ? (
            <Text
              as={Link}
              to={breadcrumb.href}
              {...styles.breadcrumbLink}
            >
              {breadcrumb.label}
            </Text>
          ) : (
            <Text {...styles.breadcrumbText}>
              {breadcrumb.label}
            </Text>
          )}
          {index < breadcrumbs.length - 1 &&
            (variant === 'jobDetails' ? (
              <BreadcrumbChevronSeparator {...styles.breadcrumbSeparator} />
            ) : (
              <Text {...styles.breadcrumbSeparator}>/</Text>
            ))}
        </React.Fragment>
      ))}
    </Flex>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ),
  variant: PropTypes.oneOf(['default', 'jobDetails', 'productDetail']),
};

export default Breadcrumbs;
